import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42e57a60"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "zIndex"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "border-inner" })
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "el-notification-fade",
    onBeforeLeave: _ctx.onClose,
    onAfterLeave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('destroy')))
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        id: _ctx.id,
        class: _normalizeClass(['el-notification', _ctx.customClass, _ctx.horizontalClass, _ctx.typeCls]),
        style: _normalizeStyle(_ctx.positionStyle),
        role: "alert",
        onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearTimer && _ctx.clearTimer(...args))),
        onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.startTimer && _ctx.startTimer(...args))),
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickNotify && _ctx.onClickNotify(...args))),
        zIndex: _ctx.zIndex
      }, [
        _hoisted_2,
        _createElementVNode("div", {
          class: _normalizeClass(["icon", _ctx.iconCls])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["el-notification__group", { 'is-with-icon': _ctx.typeClass || _ctx.iconClass }])
        }, [
          _withDirectives(_createElementVNode("div", {
            class: "el-notification__content",
            style: _normalizeStyle(!!_ctx.title ? null : 'margin: 0')
          }, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              (!_ctx.dangerouslyUseHTMLString)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.message), 1))
                : (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    innerHTML: _ctx.message
                  }, null, 8, _hoisted_4))
            ], true)
          ], 4), [
            [_vShow, _ctx.message]
          ])
        ], 2),
        (_ctx.showClose)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "el-notification__close",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["stop"]))
            }))
          : _createCommentVNode("", true)
      ], 46, _hoisted_1), [
        [_vShow, _ctx.visible]
      ])
    ]),
    _: 3
  }, 8, ["onBeforeLeave"]))
}